import styled, { css } from 'styled-components';
import checkmark from 'images/icons/checkboxTick.svg';
import glassesEmoji from 'images/icons/glassesEmoji.svg';

const alertToIconMap = {
  report: glassesEmoji,
};

export const SettingsContainer = styled.div`
  background: white;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
  width: ${({ width }) => width || 'auto'};
  height: ${({ height }) => height || '460px'};
  text-align: center;
  display: inline-block;
  vertical-align: top;
  margin-top: 5px;

  ${({ borderRight, theme }) => borderRight && css`
    border-right: 5px solid ${theme.colors.background};
  `};
`;

export const Header = styled.div``;

export const AccountIcon = styled.div`
  width: 180px;
  height: 180px;
  background: url(${({ url }) => url});
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  border: 1px solid #F7F7F7;
  box-sizing: border-box;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  border-radius: 180px;
  margin: 88px auto 25px;
`;

export const AddCompetitorButton = styled.div`
  background: #2D8BFF;
  border: 1px solid #2D8BFF;
  box-sizing: border-box;
  border-radius: 20px;
  padding: 7px 14px 7px 30px;
  color: white;
  display: inline-block;
  position: absolute;
  right: 36px;
  top: 43px;
  font-weight: bold;
  font-size: 9px;
  line-height: 13px;
  letter-spacing: 2px;
  cursor: pointer;

  &:before {
    content: '+';
    position: absolute;
    top: 7px;
    left: 12px;
    font-size: 13px;
  }
`;

export const SettingsInput = styled.input`
  width: 100%;
  font-family: Brandon;
  height: 36px;
  line-height: 32px;
  font-size: 14px;
  outline: none;
  border: none;
  color: ${({ theme }) => theme.colors.palette[5]};
  border-bottom: 1px solid #EEF5FB;

  &::placeholder {
    color: ${({ theme }) => theme.colors.palette[5]};
  }
`;

export const SettingsLabel = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 8px;
  line-height: 20px;
  letter-spacing: 2px;
  text-align: left;
  color: #B3CDE4;
  text-transform: uppercase;
`;

export const SettingsLabelInline = styled(SettingsLabel)`
  line-height: 30px;
  display: inline;
`;

export const SettingsButton = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 9px;
  line-height: 13px;
  text-align: center;
  letter-spacing: 2px;
  color: ${({ theme }) => theme.colors.palette[5]};
  border: 1px solid;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  float: right;
  margin-right: 16px;

  ${({ centered, width }) => centered && width && css`
    width: ${width};
    margin: auto;
    float: none;
  `};

  &:hover {
    color: white;
    background-color: ${({ theme }) => theme.colors.palette[5]};
  }
`;

/* Alerts Settings */

export const AlertsContainer = styled.div`
  padding-top: 36px;
  width: 100%;
  max-width: 1050px;
  margin: auto;
`;

export const AlertSection = styled.div`
  padding: 32px;
  background-color: white;
  margin-bottom: 5px;
  border-radius: 5px;
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  color: #323848;
  display: inline-block;
  background-image: ${({ type }) => `url(${alertToIconMap[type]})`};
  background-size: 30px 25px;
  background-position: 0px -1px;
  background-color: white;
  background-repeat: no-repeat;
  padding-left: 43px;
`;

export const SubAlertsContainer = styled.div`
  background: #FBFBFC;
  border-radius: 10px;
  margin-top: 24px;
  overflow: hidden;
  height: ${({ height }) => `${height}px`};
  transition: all .3s ease;
  ${({ hide }) => hide && css`
    margin-top: 0;
    height: 0;
  `}
`;

export const ToggleBlock = styled.div`
  display: inline-block;
  margin-right: ${({ mr }) => mr || 0};
`;

export const ToggleText = styled.div`
  display: inline-block;
  font-size: 14px;
  line-height: 19px;
  color: #636A7D;
  vertical-align: text-bottom;
  margin-right: 12px;
`;

export const AlertToggleContainer = styled.div`
  float: right;
  vertical-align: center;
`;

export const InnerContainer = styled.div`
  padding: 24px 0;
  border-bottom: 1px solid #F3F4F5;
`;

/* Sub Alert Rule */
export const AlertRuleContainer = styled.div`
  padding: 0 24px;

  &:last-child {
    ${InnerContainer} {
      border: none;
    }    
  }
`;

export const Checkbox = styled.div`
  width: 20px;
  height: 20px;
  background: white;
  border: 1px solid #CBCED6;
  background-image: url('${checkmark}');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 0px 0px;
  border-radius: 4px;
  display: inline-block;
  margin-right: 40px;
  vertical-align: super;
  transition: all .3s ease;

  ${({ selected }) => selected && css`
    background-color: ${({ theme }) => theme.colors.palette[4]};
    border: none;
    background-size: 9px 9px;
  `}

  &:active {
    transform: scale(0.95);
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.palette[7]};
    cursor: pointer;
  }
`;

export const RuleTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 25px;

  color: #323848;
`;

export const RuleDescription = styled.div`
  font-size: 13px;
  line-height: 18px;

  color: #939AAB;
`;
